export const INITIAL_PRICING_TEMPLATE = Object.freeze({
  merchantId: "merchant-001",
  root: {
    type: "DEFAULT",
    label: "Default",
    mdr: { percent: 0, flat: 0 },
    children: [
      {
        type: "REGION",
        label: "Domestic",
        mdr: { percent: 0, flat: 0 },
        children: [
          {
            type: "PRODUCT",
            label: "Premium",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "PRODUCT",
            label: "S Premium",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "PRODUCT",
            label: "Standard",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: "REGION",
        label: "International",
        mdr: { percent: 0, flat: 0 },
        children: [
          {
            type: "PRODUCT",
            label: "Premium",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "PRODUCT",
            label: "S Premium",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "PRODUCT",
            label: "Standard",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: "PRODUCT",
            label: "Prepaid",
            mdr: { percent: 0, flat: 0 },
            children: [
              {
                type: "CARD_TYPE",
                label: "Debit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Credit",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              },
              {
                type: "CARD_TYPE",
                label: "Prepaid",
                mdr: { percent: 0, flat: 0 },
                children: [
                  {
                    type: "SCHEME",
                    label: "Visa",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "MC",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "CUP",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JAYWAN",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  },
                  {
                    type: "SCHEME",
                    label: "JCB",
                    mdr: { percent: 0, flat: 0 },
                    children: [
                      { type: "TRANSACTION_TYPE", label: "Sales", mdr: { percent: 0, flat: 0 } },
                      { type: "TRANSACTION_TYPE", label: "Refund", mdr: { percent: 0, flat: 0 } }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
});